<template>
	<img v-bind:src="src" />
</template>

<script>
	import CommonHelper from "../../../../../../components/helpers/CommonHelper";

	export default {
		props: {
			feature: Object
		},
		computed: {
			src: {
				get: function(){
					var src = CommonHelper.svgPathToDataUri(null, this.feature);
					return src;
				}
			}
		}
	}
</script>